import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-link-with-arrow',
  templateUrl: './link-with-arrow.component.html',
  styleUrls: ['./link-with-arrow.component.scss']
})
export class LinkWithArrowComponent implements OnInit {
  @Output() linkClick = new EventEmitter<string>();

  constructor() {}
  ngOnInit() {}
}
